const curry = (f, ...args) => // eslint-disable-line no-confusing-arrow
	(f.length <= args.length)
		? f(...args)
		: (...more) =>
			curry(f, ...args, ...more);

module.exports = curry;
